import React from 'react';
import twitter from './images/twitter.svg';
import fb from './images/fb.svg';
import linkedin from './images/linkedin.svg';

const Footer = function footer() {
  return (
    <div>
      <div className="footer-top-border">
        <nav id="footer-holder">
          <div id="left-footer-nav-holder">
            <nav id="navigation">
              <ul id="navigation-items" className="footer-list">
                <li className="footer-list-header">Navigation</li>
                <li>Back to Top</li>
                <li>Home</li>
                <li>Brands</li>
                <li>Categories</li>
              </ul>
            </nav>
            <nav id="about-palletfly">
              <ul id="about-palletfly-items" className="footer-list">
                <li className="footer-list-header">About Palletfly</li>
                <li>The Mission</li>
                <li>Investor Relations</li>
                <li>Press Kit</li>
                <li>Policies</li>
                <li>Help Center</li>
              </ul>
            </nav>
            <nav id="contact-us">
              <ul id="contact-us-items" className="footer-list">
                <li className="footer-list-header">Contact Us</li>
                <li>PALLETFLY.COM LLC</li>
                <li>1946 CONEY ISLAND AVE</li>
                <li>BROOKLYN, NY 11223</li>
                <li>INFO@PALLETFLY.COM</li>
              </ul>
            </nav>
          </div>
          <div id="right-footer-icon-holder">
            <a href="https://www.linkedin.com/company/pallet-fly/" aria-label="linkedIn" target="_blank" rel="noopener noreferrer"><img id="linkedin-icon" className="footer-icon" src={linkedin} alt="" /></a>
            <a href="https://www.facebook.com/palletfly/" aria-label="facebook" target="_blank" rel="noopener noreferrer"><img id="fb-icon" className="footer-icon" src={fb} alt="" /></a>
            <a href="https://twitter.com/palletfly" aria-label="twitter" target="_blank" rel="noopener noreferrer"><img id="twitter-icon" className="footer-icon" src={twitter} alt="" /></a>
          </div>
        </nav>
      </div>
      <br />
      <div id="copyright-info" className="mb-3">© 2016-2021, PALLETFLY.COM LLC</div>
    </div>
  );
};

export default Footer;
